let activeElement;

const navigation1 = {
    trigger: $('.js-trigger-navigation1'),
    elem: $('.js-content-navigation1'),
    overlay: true,
    active: false,
    disabled: false,
    callback: false
};

const navigation2 = {
    trigger: $('.js-trigger-navigation2'),
    elem: $('.js-content-navigation2'),
    overlay: true,
    active: false,
    disabled: false,
    callback: false
};

const navigation3 = {
    trigger: $('.js-trigger-navigation3'),
    elem: $('.js-content-navigation3'),
    overlay: true,
    active: false,
    disabled: false,
    callback: false
};

const aside = {
    trigger: $('.js-trigger-aside'),
    elem: $('.js-content-aside'),
    overlay: true,
    active: false,
    disabled: false,
    callback: false,
    isAside: true,
    callback: {
        hide: function () {
            $('.js-aside-sub, .js-aside-main').removeClass('is-sided');
        }
    }
};

const minicart = {
    trigger: $('.js-trigger-minicart'),
    elem: $('.js-content-minicart'),
    overlay: false,
    active: false,
    disabled: 'cxs;xs',
    callback: false
};

const account = {
    trigger: $('.js-trigger-account'),
    elem: $('.js-content-account'),
    overlay: false,
    active: false,
    callback: false
};

const search = {
    trigger: $('.js-trigger-search'),
    elem: $('.header-search'),
    overlay: true,
    allowScroll: true,
    active: false,
    callback: {
        show: function () {
            $('.header-search').find('.c-form__input').trigger('focus');
            $('.l-header').addClass('has-active-search');
        },
        hide: function () {
            $('.l-header').removeClass('has-active-search');
            // $('.header-search').slideUp(250);
        }
    }
}

const autocomplete = {
    trigger: $('.fake'),
    elem: $('.header-search > div'),
    overlay: true,
    allowScroll: true,
    active: false,
    callback: {
        hide: function () {
            hideElem(search);
        }
    }
}

function toggleElem(object) {
    if (object.active) {
        hideElem(object);
    } else {
        showElem(object);
    }
};

function showElem(object) {
    const isAutocomplete = object == autocomplete;

    $('.filter-parameters__item .js-tabs-trigger.is-active').trigger('click');

    if (activeElement && (activeElement != search || !isAutocomplete)) {
        hideElem(activeElement);
    }

    if (!isAutocomplete) {
        object.trigger.addClass('is-active');
        object.elem.addClass('is-active');
    }

    if (object.overlay) {
        showOverlay(250);
    }

    if (object.callback && object.callback.show) {
        object.callback.show();
    }

    if (object == navigation1 || object == navigation2 || object == navigation3) {
        bLazy.revalidate();
    }

    object.active = true;

    activeElement = object;
}

function hideElem(object) {
    const isAutocomplete = object == autocomplete;

    if (isAutocomplete && checkResolution('cxs;xs')) {
        hideElem(search);
    }

    if (!isAutocomplete) {
        object.trigger.removeClass('is-active');
        object.elem.removeClass('is-active');
    }

    if (object.overlay) {
        hideOverlay();
    }

    if (object.callback && object.callback.hide) {
        object.callback.hide();
    }

    object.active = false;
}

Event.on('Autocomplete.show', function () {
    toggleElem(autocomplete);
    // showOverlay();
});

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.l-header').outerHeight();

$(window).scroll(function (event) {
    didScroll = true;
});

setInterval(function () {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(window).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta)
        return;

    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $('.l-base')
            .removeClass('nav-show')
            .addClass('has-floating-nav nav-hide');
    } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height() && st > navbarHeight) {
            $('.l-base')
                .removeClass('nav-hide')
                .addClass('has-floating-nav nav-show');
        }
        else {
            $('.l-base')
                .removeClass('has-floating-nav nav-hide nav-show');
        }
    }

    lastScrollTop = st;
}

$(function() {
    $(window).on('resize load', function () {
        hasScrolled();
    });
    /*$('.js-trigger-nav').on('click', function(event) {
        const $navLink = $(this);

        event.preventDefault();

        if ($navLink.hasClass('is-active')) {
            $navLink.removeClass('is-active');

            navigation.active = false;
        } else {
            $('.js-trigger-nav.is-active').removeClass('is-active');
            $navLink.addClass('is-active');

            navigation.active = true;
            activeElement = navigation;
        }
    });*/

    $('body').on('click', function (event) {
        if (!$(event.target).closest($('.catalog__filter')).length) {
            $('.filter-parameters__item .js-tabs-trigger.is-active').trigger('click');
        }

        if (activeElement && activeElement.active) {
            if (!$(event.target).closest(activeElement.elem).length && !$(event.target).closest(activeElement.trigger).length) {
                hideElem(activeElement);
            }
        }
    });

    for (const object of [aside, navigation1, navigation2, navigation3, minicart, account, search]) {
        object.trigger.on('click', function (event) {
            if (object.isAside) {
                const headerMarginBottom = parseInt($('.l-header').css('marginBottom'));

                if (headerMarginBottom) {
                    $('.js-content-aside').css('top', -(headerMarginBottom - 1));
                }
            }

            if (!object.disabled || (object.disabled && !checkResolution(object.disabled))) {
                event.preventDefault();

                toggleElem(object);
            }
            else {
                hideElem(object);
            }
        });
    }

    $('.js-content-navigation1 .js-close-subnav').on('click', function(event) {
        hideElem(navigation1);
    });

    $('.js-content-navigation2 .js-close-subnav').on('click', function (event) {
        hideElem(navigation2);
    });

    $('.js-content-navigation3 .js-close-subnav').on('click', function (event) {
        hideElem(navigation3);
    });

    $('.js-close-search').on('click', function (event) {
        hideElem(search);
    });

    $('.js-aside-sub-trigger').on('click', function(e) {
        if (!$('.js-aside-sub').length) {
            return true;
        }

        let dataBoxId;

        e.preventDefault();

        dataBoxId = $(this).data('box-id');
        
        $('.js-aside-sub[data-box-id="' + dataBoxId + '"], .js-aside-main').addClass('is-sided');
    });

    $('.js-aside-sub-back').on('click', function(e) {
        e.preventDefault();

        $('.js-aside-sub, .js-aside-main').removeClass('is-sided');
    });
});
